import { addToast } from '@mobi/component-library/Feedback/Toast'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { showLogin } from '@core/Areas/Login/helpers'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import { queryKeys } from '@mobi/account/Utils'
import { postPreferencesToApi } from './api'

export function autoOptInMarketingCommunications() {
  userAccountState$.take(1).subscribe(record => {
    if (record.isLoggedIn) {
      handleAutoOptIn()
    } else {
      showLogin({ onLoginSuccessCallback: handleAutoOptIn })
    }
  })
}

// =============
// Local Helpers
// =============

function handleAutoOptIn() {
  postPreferencesToApi({ Email: true, Sms: true, Phone: true, Mail: true, Marketing: true })
    .then(() => {
      addToast({
        id: 'marketing-auto-opt-in-success',
        title: 'Successfully updated preferences',
        icon: 'success',
      })

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.betAccount] })
      }, 2_000)
    })
    .catch(() => {
      addToast({
        id: 'marketing-auto-opt-in-fail',
        title: 'Unable to update preferences',
        icon: 'error',
      })
    })
}
